<template>
  <el-dialog class="wx-dialog" :title="title" :visible.sync="options.show" close="cancel" :width="options.width">
    <div class="reset-info">
      <div class="alside-left"  v-html="contentMain.content"></div>
      <div class="alside-right" >
        <ul>
          <li>共有25个版本</li>
          <li v-for="(item, $index) in lists" :key="$index" @click="chooseClick(item)">
            <span>{{item.createdat}}</span>
            <span>{{item.createdat | WeekDate}}</span>
          </li>
        </ul>
        <div v-infinite-scroll="hideScroll" :infinite-scroll-disabled="busy" :infinite-scroll-distance="10"></div>
      </div>
    </div>
    <div v-if="contentMain" slot="footer" class="footer-dialog-article" style="text-align:center;margin-top:10px">
      <el-button type="success" @click="submit('uiEduction')">恢复成{{btnTxt}}  的版本</el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import ArticleService from '@/service/api/articleService'

export default {
  props: {
    metaData: {
      type: Object,
      default: {}
    },
    cancelFn: {
      type: Function,
      default: () => undefined
    },
    submitFn: {
      type: Function,
      default: () => undefined
    },
    options: {
      type: Object,
      default: {}
    },
    title: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      lists: [],
      searchVal: {
        tag: null,
        page: 1,
        type: 0
      },
      busy: false,
      contentMain: {},
      total: 1,
      selectedUserList: [],
      btnTxt: null
    }
  },

  created () {
    this.getList()
  },

  methods: {
    chooseClick (obj) {
      this.contentMain = obj
      this.btnTxt = obj.createdat
    },
    getList (flag) {
      const articleSystem = new ArticleService()
      articleSystem.articleList(this.searchVal)
        .then(({ data }) => {
          if(flag){
            // 多次加载数据
            this.lists = [
              ...this.lists,
              ...data.data
            ]
            if(data.data.length === 0){
              this.busy = true;
            }else{
              this.busy = false;
            }
          }else{
            // 第一次加载数据
            this.lists = data.data;
            // 当第一次加载数据完之后，把这个滚动到底部的函数触发打开
            this.busy = false;
          }
        }, (error) => {
          this.$notify.error(error.message)
      })
    },
    hideScroll () {
      this.busy = true;
      // 多次加载数据
      setTimeout(() => {
        if (this.searchVal.page > this.total) {
          return
        } else {
          this.searchVal.page ++;
          this.getList(true);
        }
      }, 1000);
    },
    submit () {
      if (this.submitFn && typeof this.submitFn === 'function') {
        this.submitFn(this.contentMain)
      }
      this.$destroy()
    },

    cancel () {
      if (this.cancelFn && typeof this.cancelFn === 'function') {
        this.cancelFn()
      }
      this.$destroy()
    }
  },

  destroyed () {
    document
      .getElementById('app')
      .removeChild(this.$el)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .reset-info{
    display: flex;
    align-items: flex-start;
    .alside-left{
      padding: 10px 0;
      width: 500px;
      margin-top: 10px;
      max-height: 580px;
      overflow: auto;
    }
    .alside-right{
      background: #eee;
      border-radius: 2px;
      width: 400px;
      margin: 10px;
      ul{
        max-height: 580px;
        overflow-y: auto;
        li{
          display: flex;
          justify-content: space-around;
          align-items: center;
          line-height: 36px;
          border-top: solid 1px #fff;
          cursor: pointer;
          &:hover{
            background: #67c23a;
            color:#fff;
          }
          &:first-child{
            border: none;
            font-weight: bold;
            line-height: 40px;
          }
          &:first-child:hover{
            background: #eee;
            color: #606266
          }
        }
      }
    }
    .icon-left{
      margin: 0 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/restoreData.vue